<div>
  <a
    href="#main-content"
    (focus)="onSkipLinkFocus()"
    (focusout)="onSkipLinkFocusOut()"
    appSkipLink
    class="skip-link">
    {{ 'accessibility.skipToContent' | translate }}
  </a>
</div>
